/**
* 前台总入口
* Created by dxw on 2020/03/17.
*/
<template>
  <div class="entrance">
    <router-view></router-view>
  </div>
</template>

<script>
  import appConfig from '../appConfig'

  export default {
    name: 'entrance',
    data() {
      return {
        //前台
        homeUrl: appConfig.API.LOGIN_URL,
        //商城
        mallUrl: appConfig.API.RECEPTION_URL,

      }
    },
    watch: {
      '$route': function () {
        console.log("路由更新")
        this.verificationheadToMobile()
      },
    },
    methods: {
      // 验证是否需要前往web
      verificationheadToMobile() {
        // console.log(this.$route)
        let isWeb = this.$route.meta.isWeb
        if (isWeb) {
          //是否PC端验证（并自动跳转PC端）
          if (!this.checkMobile()) {
            let matched = this.$route.matched,
              query = this.$route.query,
              params = this.$route.params,
              webPath = this.$route.meta.webPath,
              path = matched[matched.length - 1].path,
              project = this.$route.meta.project

            if (webPath) {
              path = webPath
            }

            if (path.indexOf(':') > -1) {
              let obj = Object.assign({}, params, query)
              path = this.urlParamsEncode(obj, path)
            }

            // let paramList = Object.getOwnPropertyNames(query)

            //格式化参数
            let queryList = Object.getOwnPropertyNames(query)
            if (queryList && queryList.length > 0) {
              let parseParam = this.urlQueryEncode(query)
              if (parseParam) {
                path = path + "?" + parseParam
              }
            }

            // console.log("跳转PC端")
            // console.log(path)
            if (project == 'mall') {//前往商城
              this.automatic(this.mallUrl + path, '_self')
            } else {//前往前台
              this.automatic(this.homeUrl + path, '_self')
            }
          }
        }
      },

      //格式化url的query参数
      urlQueryEncode(param, key, encode, index = 0) {
        if (param == null) return '';
        let paramStr = '';
        let t = typeof (param);
        if (t == 'string' || t == 'number' || t == 'boolean') {
          paramStr += (index === 0 ? '' : '&') + key + '=' + ((encode == null || encode) ? encodeURIComponent(param) : param);
          index++
        } else {
          for (let i in param) {
            let k = key == null ? i : key + (param instanceof Array ? '[' + i + ']' : '.' + i);
            paramStr += this.urlQueryEncode(param[i], k, encode, index);
            index++
          }
        }
        return paramStr;
      },

      //格式化url的params参数
      urlParamsEncode(params, path = '') {
        if (!params || !path) return '';
        let pathList = path.toString().split('\/'), pathStr = ''

        if (pathList && pathList.length > 0) {
          pathList.forEach(item => {
            if (item) {
              if (item.indexOf(':') === 0) {
                let k = item.split(':')[1]
                // console.log("分解参数")
                // console.log(k)
                pathStr += '/' + params[k]
              } else {
                pathStr += '/' + item
              }
            }
          })
        }
        return pathStr
      },

    },
    created() {
    },
    mounted() {
      this.verificationheadToMobile()
    }
  }
</script>


<style lang="stylus" type="text/stylus">
  .entrance {
    width: 100%;
    height: 100%;

  }
  .van-toast {
    width 0.88rem
    min-height 0.88rem
    padding 0.16rem
    font-size 0.14rem
    line-height 0.2rem
    border-radius 0.08rem
    .van-icon {
      font-size 0.36rem
    }
  }
  .van-tabbar {
    z-index 2
  }
  h1, h2 {
    font-weight: normal;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #587ff8;
  }

</style>



// WEBPACK FOOTER //
// src/pages/index.vue